import { render } from "./SearchCustomers.vue?vue&type=template&id=efe0f70a"
import script from "./SearchCustomers.vue?vue&type=script&lang=js"
export * from "./SearchCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__